import { render, staticRenderFns } from "./CarouselComponent.vue?vue&type=template&id=752f4a46&scoped=true"
import script from "./CarouselComponent.vue?vue&type=script&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&lang=js"
import style0 from "./CarouselComponent.vue?vue&type=style&index=0&id=752f4a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f4a46",
  null
  
)

export default component.exports